// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"552":"67ec045b","697":"b88e2fbe","3213":"42046fac","4938":"c8936535","6233":"a6ded447","8605":"1742b132"}[chunkId] + ".chunk.css";
};